import type { AnyAction, Middleware, MiddlewareAPI } from '@reduxjs/toolkit'
import { FORBIDDEN_ERROR_CODE } from '../../commons/constants/constants'
import { setError } from '../slices/errorSlice'
import { endpoints as authEndpoints } from './authApi'

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) =>
  (next) =>
  (action: AnyAction) => {
    if (action?.payload?.status === FORBIDDEN_ERROR_CODE) {
      api.dispatch(authEndpoints.logout.initiate() as unknown as AnyAction)
    }
    if (action?.payload?.error) {
      if (action.payload.error.code === FORBIDDEN_ERROR_CODE) {
        api.dispatch(authEndpoints.logout.initiate() as unknown as AnyAction)
      } else {
        api.dispatch(setError())
      }
    } else if (action?.payload?.data?.error) {
      if (action.payload.status === FORBIDDEN_ERROR_CODE) {
        api.dispatch(authEndpoints.logout.initiate() as unknown as AnyAction)
      }
    }
    return next(action)
  }
